import React from "react";
import PropTypes from "prop-types";
import styles from "./PublishStatusIcon.module.css";

import CheckCircleIcon from "../../assests/circle-check.svg";
import MinusCircleIcon from "../../assests/circle-minus.svg";
import CircleIcon from "../../assests/circle-regular.svg";
import classNames from "classnames";

/**
 * View component.
 * An icon that displays the publish status of a feed.
 */
export function PublishStatusIcon({ status }) {
  return (
    <img
      alt="Publish Status Icon"
      className={classNames(styles.icon, {
        [styles.transparent]: status === "Storaged",
      })}
      src={
        status === "Published"
          ? CheckCircleIcon
          : status === "Unpublished"
          ? CircleIcon
          : status === "Archived"
          ? MinusCircleIcon
          : CircleIcon
      }
    />
  );
}

PublishStatusIcon.propTypes = {
  /**
   * String that determines the status type of the icon.
   * "Storaged" has no icon.
   */
  status: PropTypes.oneOf(["Published", "Unpublished", "Archived", "Storaged"]),
};
